import { AppData, BookingData, Step } from "../../types";

import { BackFromBookingQuestionsStepPayload } from "../../actions";
import { getBookingQuestionsPreviousStep } from "../../../utils";
import { Mixpanel } from "../../../mixpanel/mixpanel";
import { PartRequired } from "../../../utils/types";
import { requireBookingDataFields } from "../../../utils/requireBookingDataFields/requireBookingDataFields";

export type BackFromBookingQuestionsStepOptions = {
  appData: AppData;
  payload: BackFromBookingQuestionsStepPayload;
};

export const backFromBookingQuestionsStep = (
  options: BackFromBookingQuestionsStepOptions,
): AppData => {
  Mixpanel.track({ name: "Went back", props: { from: "bookingQuestions" } });
  const urlParams = new URLSearchParams(window.location.search);
  const prefilledOrganisationId = urlParams.get("organisationId");

  const updatedBookingData: BookingData = {
    ...options.appData.bookingData,
    ...options.payload.updatedData,
  };

  requireBookingDataFields<PartRequired<BookingData, "organisation">>(
    updatedBookingData,
    ["organisation"],
  );

  const { organisation } = updatedBookingData;

  const previousStep: Step = getBookingQuestionsPreviousStep({
    bookingData: updatedBookingData,
    bookingTool: options.appData.bookingTool,
    organisation,
  });

  if (previousStep === "locationAvailability" && !prefilledOrganisationId) {
    delete updatedBookingData.resource;
    delete updatedBookingData.service;
    delete (updatedBookingData as Partial<BookingData>).organisation;
  }

  if (previousStep === "resources") {
    delete updatedBookingData.resource;
    delete updatedBookingData.resourceGroupId;
  }

  return {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: previousStep,
  };
};
